var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHome = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M20.84 11.14 18 8.46v-5a.5.5 0 0 0-.5-.5h-2a.5.5 0 0 0-.5.5v2.17l-2.65-2.5a.52.52 0 0 0-.68 0l-8.5 8a.5.5 0 0 0 .33.87H6v8.5a.5.5 0 0 0 .5.5H10v-5.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5V21h3.5a.5.5 0 0 0 .5-.5V12h2.5a.5.5 0 0 0 .34-.86Z"
})));
export default SvgHome;